var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup48095510(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 49,
    viewBox: "0 0 65 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 16.5,
    r: 31.5,
    fill: "#FFE6F8",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1442 26.2821C34.1156 26.2821 34.0863 26.2795 34.0568 26.2732C34.0283 26.2679 34.0007 26.259 33.974 26.2483C33.9473 26.2367 33.9214 26.2233 33.8973 26.2073C33.8724 26.1903 33.85 26.1717 33.8296 26.1511C33.7467 26.0683 33.6986 25.9542 33.6986 25.8366C33.6986 25.719 33.7468 25.604 33.8296 25.5211C33.85 25.5007 33.8724 25.4819 33.8973 25.4659C33.9214 25.4499 33.9473 25.4365 33.974 25.4249C34.0007 25.4143 34.0283 25.4053 34.0568 25.3999C34.1148 25.3883 34.1736 25.3883 34.2315 25.3999C34.26 25.4053 34.2876 25.4142 34.3144 25.4249C34.342 25.4365 34.3678 25.4499 34.3919 25.4659C34.416 25.4819 34.4392 25.5007 34.4597 25.5211C34.5425 25.604 34.5897 25.719 34.5897 25.8366C34.5897 25.8651 34.587 25.8945 34.5809 25.9239C34.5755 25.9515 34.5666 25.9801 34.5559 26.0068C34.5443 26.0335 34.5309 26.0594 34.5149 26.0835C34.4989 26.1084 34.4802 26.1307 34.4597 26.1512C34.4392 26.1717 34.416 26.1904 34.3919 26.2074C34.3678 26.2234 34.342 26.2368 34.3144 26.2483C34.2876 26.2591 34.26 26.2679 34.2315 26.2733C34.203 26.2795 34.1737 26.2821 34.1442 26.2821Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6985 31.7241C33.6985 31.4782 33.8981 31.2786 34.144 31.2786C34.3899 31.2786 34.5895 31.4782 34.5895 31.7241C34.5895 31.9701 34.3899 32.1696 34.144 32.1696C33.898 32.1697 33.6985 31.9701 33.6985 31.7241ZM33.6985 29.7619C33.6985 29.5151 33.8981 29.3155 34.144 29.3155C34.3899 29.3155 34.5895 29.5151 34.5895 29.7619C34.5895 30.0078 34.3899 30.2074 34.144 30.2074C33.898 30.2074 33.6985 30.0078 33.6985 29.7619ZM33.6985 27.7988C33.6985 27.5529 33.8981 27.3533 34.144 27.3533C34.3899 27.3533 34.5895 27.5529 34.5895 27.7988C34.5895 28.0448 34.3899 28.2443 34.144 28.2443C33.898 28.2443 33.6985 28.0447 33.6985 27.7988Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1441 34.1318C34.1155 34.1318 34.0861 34.1292 34.0567 34.1229C34.0281 34.1176 34.0005 34.1087 33.9738 34.098C33.9471 34.0864 33.9213 34.073 33.8972 34.057C33.8722 34.0409 33.8499 34.0222 33.8294 34.0017C33.8089 33.9813 33.7902 33.9582 33.7732 33.9341C33.7573 33.91 33.7438 33.8842 33.7323 33.8566C33.7216 33.8298 33.7127 33.8022 33.7073 33.7737C33.7011 33.7452 33.6984 33.7158 33.6984 33.6863C33.6984 33.5696 33.7465 33.4546 33.8293 33.3717C33.8498 33.3513 33.8721 33.3325 33.8971 33.3156C33.9212 33.2995 33.947 33.2861 33.9737 33.2746C34.0004 33.2639 34.028 33.255 34.0566 33.2497C34.1145 33.2381 34.1733 33.2381 34.2312 33.2497C34.2597 33.255 34.2874 33.2639 34.3141 33.2746C34.3417 33.2862 34.3676 33.2996 34.3916 33.3156C34.4157 33.3325 34.4389 33.3512 34.4594 33.3717C34.5423 33.4546 34.5895 33.5696 34.5895 33.6863C34.5895 33.7158 34.5868 33.7451 34.5806 33.7737C34.5752 33.8022 34.5664 33.8298 34.5556 33.8566C34.544 33.8842 34.5307 33.91 34.5147 33.9341C34.4986 33.9582 34.48 33.9813 34.4594 34.0017C34.4389 34.0222 34.4157 34.0409 34.3916 34.057C34.3676 34.0731 34.3417 34.0865 34.3141 34.098C34.2873 34.1087 34.2597 34.1176 34.2312 34.1229C34.2029 34.1292 34.1735 34.1318 34.1441 34.1318Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2806 20.0555V16.5344L46.226 13.3268V9.78847L19.557 8.58472V12.1698L16.8882 12.987V16.4463C16.8854 16.4732 16.8847 16.5004 16.8882 16.5284L17.1524 18.6529C17.1874 18.934 17.5411 19.1943 18.0189 19.2907L20.9423 19.8803V23.2779C20.9573 23.4448 21.0877 23.6155 21.3181 23.7486L24.107 25.3587C24.4759 25.5717 25.0121 25.6365 25.4204 25.5175L29.1005 24.4441C29.5027 24.5674 29.9111 24.6787 30.324 24.7776L31.8283 27.2637C31.9952 27.5395 32.4462 27.7436 32.933 27.7639L36.6129 27.9164C37.0997 27.9366 37.5043 27.7679 37.604 27.5031L38.5024 25.1167C38.8949 25.0512 39.2796 24.9728 39.6553 24.8817L43.6418 26.2729C44.0842 26.4272 44.6097 26.4065 44.9291 26.222L47.3444 24.8275C47.5034 24.7357 47.592 24.6144 47.6082 24.4843C47.6116 24.4576 47.611 24.4305 47.6082 24.4032V20.9429L47.4863 20.859L49.5633 20.5984C50.0056 20.5429 50.2923 20.3233 50.2806 20.0555Z",
    fill: "url(#paint0_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5631 20.5983C50.0056 20.5428 50.2923 20.3232 50.2805 20.0554V16.5343L45.3377 15.8593L45.0228 18.2411L47.486 20.8589L49.5631 20.5983Z",
    fill: "url(#paint1_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9289 26.2218L47.3441 24.8273C47.5031 24.7355 47.5918 24.6142 47.608 24.4841C47.6113 24.4574 47.6108 24.4303 47.608 24.403V20.9427L39.655 21.3402V24.8816L43.6416 26.2727C44.0838 26.4271 44.6093 26.4063 44.9289 26.2218Z",
    fill: "url(#paint2_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9328 27.7638L36.6127 27.9164C37.0995 27.9366 37.5041 27.7679 37.6037 27.5031L38.5022 25.1167V21.5752L30.3239 21.2362V24.7777L31.8282 27.2637C31.9951 27.5395 32.4461 27.7436 32.9328 27.7638Z",
    fill: "url(#paint3_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9422 19.7366C20.9422 19.7366 20.9231 19.7845 20.889 19.8696L20.9422 19.8804V23.2779C20.9572 23.4449 21.0876 23.6155 21.318 23.7486L24.1069 25.3588C24.4759 25.5717 25.012 25.6365 25.4203 25.5175L29.1004 24.4442V20.9028L20.9422 19.7366Z",
    fill: "url(#paint4_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7469 7.49562L38.0669 8.56894C37.6646 8.44563 37.2563 8.33436 36.8434 8.23557L35.3391 5.74949C35.1722 5.4736 34.7212 5.26943 34.2344 5.24931L30.5545 5.09673C30.0677 5.07651 29.6631 5.24526 29.5635 5.51008L28.665 7.89648C28.2726 7.96187 27.8879 8.04036 27.5123 8.13142L23.5257 6.74028C23.0834 6.58595 22.5579 6.60669 22.2384 6.79117L19.8232 8.18565C19.5037 8.37013 19.4676 8.67353 19.735 8.92894L22.1445 11.2305C21.9869 11.4474 21.851 11.6695 21.7377 11.8961L17.6043 12.4149C17.1457 12.4724 16.8534 12.7059 16.8883 12.987L17.1525 15.1116C17.1875 15.3927 17.5412 15.653 18.0189 15.7494L22.3249 16.618C22.496 16.8563 22.6888 17.092 22.9023 17.3243L21.0433 19.449C20.837 19.6847 20.9492 19.9943 21.3181 20.2073L24.1069 21.8175C24.4759 22.0305 25.012 22.0953 25.4204 21.9762L29.1005 20.9029C29.5027 21.0261 29.9111 21.1375 30.324 21.2363L31.8283 23.7222C31.9952 23.998 32.4462 24.2023 32.933 24.2224L36.6129 24.375C37.0997 24.3952 37.5043 24.2265 37.604 23.9617L38.5024 21.5753C38.8948 21.5099 39.2796 21.4314 39.6552 21.3404L43.6418 22.7315C44.0841 22.8859 44.6096 22.8651 44.9291 22.6807L47.3443 21.2862C47.6638 21.1017 47.6999 20.7983 47.4325 20.5429L45.023 18.2413C45.1807 18.0245 45.3165 17.8023 45.4298 17.5757L49.5632 17.057C50.0219 16.9994 50.3141 16.7659 50.2792 16.4848L50.015 14.3602C49.98 14.0792 49.6263 13.8188 49.1486 13.7224L44.8426 12.8539C44.6715 12.6155 44.4787 12.3798 44.2652 12.1475L46.1243 10.0228C46.3305 9.7871 46.2183 9.47755 45.8494 9.2645L43.0606 7.65435C42.6914 7.4413 42.1552 7.37652 41.7469 7.49562Z",
    fill: "url(#paint5_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3239 24.7775L29.1003 24.4442V20.9027L30.3239 21.2362V24.7775Z",
    fill: "url(#paint6_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5022 25.1165V21.5751L39.6551 21.3402V24.8817L38.5022 25.1165Z",
    fill: "url(#paint7_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3146 14.217V15.6493L42.3129 15.6492C42.3455 16.761 41.6911 17.8267 40.3203 18.6181C37.3663 20.3236 32.2065 20.1097 28.7955 18.1404C26.9811 17.0928 26.027 15.7596 25.976 14.4843L25.9738 14.4842V12.8513L42.3146 14.217Z",
    fill: "url(#paint8_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9683 9.96828C30.9223 8.26276 36.0821 8.47669 39.4931 10.4461C42.904 12.4154 43.2745 15.3944 40.3205 17.0999C37.3665 18.8054 32.2067 18.5915 28.7957 16.6222C25.3847 14.6528 25.0143 11.6738 27.9683 9.96828Z",
    fill: "url(#paint9_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 11.7764C32.5559 10.9357 35.0993 11.0412 36.7806 12.0119C38.462 12.9826 38.6446 14.451 37.1885 15.2917C35.7324 16.1323 33.1891 16.0269 31.5077 15.0562C29.8264 14.0855 29.6437 12.6171 31.0998 11.7764Z",
    fill: "url(#paint10_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6518 15.5067C47.4057 15.5067 47.2063 15.3072 47.2063 15.0612V4.46859C47.2063 4.2225 47.4058 4.02307 47.6518 4.02307C47.8978 4.02307 48.0973 4.22258 48.0973 4.46859V15.0611C48.0973 15.3072 47.8978 15.5067 47.6518 15.5067Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1441 15.7519C34.0274 15.7519 33.9124 15.7047 33.8295 15.6219C33.8091 15.6014 33.7903 15.5782 33.7734 15.5541C33.7574 15.53 33.7439 15.5042 33.7324 15.4775C33.7217 15.4499 33.7128 15.4222 33.7075 15.3937C33.7012 15.3652 33.6985 15.3358 33.6985 15.3063C33.6985 15.1896 33.7466 15.0747 33.8294 14.9918C33.8499 14.9713 33.8722 14.9526 33.8972 14.9366C33.9213 14.9205 33.9471 14.9063 33.9738 14.8956C34.0006 14.884 34.0282 14.876 34.0567 14.8698C34.1146 14.8582 34.1734 14.8582 34.2314 14.8698C34.2598 14.876 34.2875 14.884 34.3142 14.8956C34.3418 14.9063 34.3677 14.9206 34.3918 14.9366C34.4158 14.9526 34.4391 14.9713 34.4595 14.9918C34.5424 15.0747 34.5896 15.1896 34.5896 15.3063C34.5896 15.3358 34.5869 15.3651 34.5807 15.3937C34.5754 15.4222 34.5665 15.4499 34.5558 15.4775C34.5442 15.5042 34.5308 15.53 34.5148 15.5541C34.4987 15.5782 34.4801 15.6014 34.4595 15.6219C34.4391 15.6423 34.4158 15.6611 34.3918 15.6771C34.3677 15.6931 34.341 15.7075 34.3142 15.7181C34.2874 15.7297 34.2598 15.7377 34.2314 15.7439C34.2029 15.7492 34.1735 15.7519 34.1441 15.7519Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6986 13.5748C33.6986 13.328 33.8982 13.1293 34.1441 13.1293C34.39 13.1293 34.5896 13.3281 34.5896 13.5748C34.5896 13.8209 34.39 14.0204 34.1441 14.0204C33.8981 14.0205 33.6986 13.8209 33.6986 13.5748ZM33.6986 11.8425C33.6986 11.5966 33.8982 11.397 34.1441 11.397C34.39 11.397 34.5896 11.5966 34.5896 11.8425C34.5896 12.0885 34.39 12.2881 34.1441 12.2881C33.8981 12.2881 33.6986 12.0885 33.6986 11.8425ZM33.6986 10.1103C33.6986 9.86437 33.8982 9.66468 34.1441 9.66468C34.39 9.66468 34.5896 9.86428 34.5896 10.1103C34.5896 10.3562 34.39 10.5558 34.1441 10.5558C33.8981 10.5558 33.6986 10.3562 33.6986 10.1103ZM33.6986 8.37796C33.6986 8.13196 33.8982 7.93245 34.1441 7.93245C34.39 7.93245 34.5896 8.13205 34.5896 8.37796C34.5896 8.62388 34.39 8.82348 34.1441 8.82348C33.8981 8.82348 33.6986 8.62388 33.6986 8.37796ZM33.6986 6.64652C33.6986 6.39972 33.8982 6.201 34.1441 6.201C34.39 6.201 34.5896 6.39972 34.5896 6.64652C34.5896 6.89252 34.39 7.09203 34.1441 7.09203C33.8981 7.09203 33.6986 6.89244 33.6986 6.64652ZM33.6986 4.91419C33.6986 4.66828 33.8982 4.46868 34.1441 4.46868C34.39 4.46868 34.5896 4.66828 34.5896 4.91419C34.5896 5.1602 34.39 5.35971 34.1441 5.35971C33.8981 5.35971 33.6986 5.16011 33.6986 4.91419ZM33.6986 3.18187C33.6986 2.93595 33.8982 2.73635 34.1441 2.73635C34.39 2.73635 34.5896 2.93595 34.5896 3.18187C34.5896 3.42788 34.39 3.62739 34.1441 3.62739C33.8981 3.62739 33.6986 3.42788 33.6986 3.18187ZM33.6986 1.44955C33.6986 1.20354 33.8982 1.00403 34.1441 1.00403C34.39 1.00403 34.5896 1.20363 34.5896 1.44955C34.5896 1.69546 34.39 1.89506 34.1441 1.89506C33.8981 1.89515 33.6986 1.69546 33.6986 1.44955ZM33.6986 -0.2819C33.6986 -0.528697 33.8982 -0.727417 34.1441 -0.727417C34.39 -0.727417 34.5896 -0.528697 34.5896 -0.2819C34.5896 -0.0358939 34.39 0.163618 34.1441 0.163618C33.8981 0.163706 33.6986 -0.0358939 33.6986 -0.2819Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5794 23.686C11.5025 23.686 11.4255 23.6661 11.3566 23.6263C11.2188 23.5467 11.1338 23.3996 11.1338 23.2405V15.3464C11.1338 15.1004 11.3333 14.9009 11.5793 14.9009C11.8253 14.9009 12.0248 15.1004 12.0248 15.3464V22.4687L19.9623 17.8856C20.1754 17.7626 20.4479 17.8356 20.571 18.0487C20.694 18.2617 20.621 18.5343 20.4079 18.6573L11.8022 23.6262C11.7332 23.666 11.6563 23.686 11.5794 23.686Z",
    fill: "#43386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3832 -3.83881L40.3828 -3.83793C39.9816 -4.06723 39.4596 -4.04526 38.8884 -3.71541C37.623 -2.98486 36.5972 -1.02481 36.5972 0.662337C36.5972 1.58035 36.9013 2.22758 37.382 2.51006L38.7144 3.27682L41.736 -3.06045L40.3832 -3.83881Z",
    fill: "url(#paint11_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4967 -1.22657C42.4967 -2.91372 41.471 -3.68926 40.2055 -2.95872C38.9402 -2.22817 37.9143 -0.268121 37.9143 1.41903C37.9143 3.10618 38.9401 3.88172 40.2055 3.15109C41.471 2.42063 42.4967 0.460668 42.4967 -1.22657Z",
    fill: "url(#paint12_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7364 -2.12315L50.4136 -2.8827C50.2686 -2.9626 50.0812 -2.95354 49.8764 -2.83524L44.0532 0.526837C43.5933 0.792355 43.2206 1.50462 43.2206 2.11774V5.255C43.2206 5.58688 43.3304 5.82049 43.5034 5.92402L44.784 6.65984L51.7364 -2.12315Z",
    fill: "url(#paint13_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1673 -2.0944L45.3441 1.26768C44.8842 1.5332 44.5115 2.24547 44.5115 2.85859V5.99585C44.5115 6.60897 44.8842 6.89075 45.3441 6.62532L51.1673 3.26324C51.6272 2.99772 52 2.28546 52 1.67233V-1.46501C52 -2.07814 51.6273 -2.35992 51.1673 -2.0944Z",
    fill: "url(#paint14_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5159 10.9232L14.1931 10.1637C14.0481 10.0838 13.8607 10.0928 13.6559 10.2111L7.83259 13.5732C7.37274 13.8387 7 14.551 7 15.1641V18.3014C7 18.6333 7.10978 18.8669 7.28283 18.9703L8.5634 19.7061L15.5159 10.9232Z",
    fill: "url(#paint15_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9468 10.9519L9.12348 14.314C8.66364 14.5795 8.29089 15.2918 8.29089 15.9049V19.0422C8.29089 19.6553 8.66364 19.9371 9.12357 19.6717L14.9469 16.3096C15.4067 16.0441 15.7795 15.3318 15.7795 14.7187V11.5814C15.7794 10.9683 15.4066 10.6865 14.9468 10.9519Z",
    fill: "url(#paint16_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2393 21.0165C18.9196 20.8164 18.4961 20.8267 18.0315 21.095C17.0355 21.67 16.228 23.2129 16.228 24.5409C16.228 25.2933 16.4873 25.8152 16.8931 26.0219L22.8946 29.4252L25.318 24.4648L19.2393 21.0165Z",
    fill: "url(#paint17_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1371 22.3746C21.7866 22.1553 21.3224 22.1666 20.813 22.4607C19.7211 23.0911 18.8359 24.7824 18.8359 26.2383C18.8359 27.0631 19.1201 27.6353 19.565 27.8618L22.4503 29.4916C23.1923 29.9107 24.1341 29.6182 24.5081 28.8525L25.8631 26.0789C26.2069 25.3754 25.9432 24.5258 25.2615 24.1406L22.1371 22.3746Z",
    fill: "url(#paint18_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2479 24.4302C24.9244 24.2278 24.4958 24.2382 24.0258 24.5096C23.0179 25.0914 22.2008 26.6526 22.2008 27.9964C22.2008 28.7577 22.4632 29.2859 22.8738 29.4949L35.2256 36.4823L37.6777 31.4631L25.2479 24.4302Z",
    fill: "url(#paint19_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7816 36.9887C41.185 37.0168 41.4386 36.5622 41.2028 36.2338L37.9875 31.7543C37.9864 31.7529 37.9855 31.7515 37.9844 31.75C37.6562 31.294 37.1017 31.19 36.4728 31.5531C35.4649 32.135 34.6478 33.6961 34.6478 35.0399C34.6478 36.039 35.0996 36.6361 35.7454 36.638L40.7816 36.9887Z",
    fill: "url(#paint20_linear_715_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2204 36.88L40.7815 36.9888C41.1848 37.0168 41.4384 36.5622 41.2026 36.2338L40.1894 34.8223L40.1888 34.8234C40.0522 34.599 39.8039 34.5388 39.5193 34.7032C39.0877 34.9523 38.7379 35.6207 38.7379 36.1961C38.7379 36.5864 38.8992 36.833 39.1375 36.8739L39.1373 36.8742L39.1398 36.8744C39.1659 36.8787 39.1927 36.8807 39.2204 36.88Z",
    fill: "#43386B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_335",
    x1: 16.6069,
    y1: 18.2514,
    x2: 23.7021,
    y2: 18.2514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_335",
    x1: 47.5088,
    y1: 18.3591,
    x2: 50.6333,
    y2: 18.3591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_335",
    x1: 43.4161,
    y1: 23.6593,
    x2: 45.0533,
    y2: 23.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_335",
    x1: 31.3992,
    y1: 24.5771,
    x2: 34.2943,
    y2: 24.5771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_335",
    x1: 24.1403,
    y1: 22.6566,
    x2: 25.8044,
    y2: 22.6566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_335",
    x1: 21.2345,
    y1: 7.60609,
    x2: 46.367,
    y2: 22.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_335",
    x1: 30.286,
    y1: 22.8402,
    x2: 28.353,
    y2: 22.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_335",
    x1: 39.9123,
    y1: 23.2284,
    x2: 38.1598,
    y2: 23.2284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_335",
    x1: 40.1964,
    y1: 16.3103,
    x2: 31.654,
    y2: 16.3103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_335",
    x1: 27.9947,
    y1: 9.98357,
    x2: 41.2605,
    y2: 17.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_335",
    x1: 36.1338,
    y1: 14.6828,
    x2: 30.2259,
    y2: 11.2718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_715_335",
    x1: 38.4466,
    y1: -0.098005,
    x2: 40.7809,
    y2: -4.14133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_715_335",
    x1: 40.2055,
    y1: 5.14401,
    x2: 40.2055,
    y2: -0.707223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_335",
    x1: 45.7154,
    y1: 2.7974,
    x2: 46.4137,
    y2: 1.58785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_335",
    x1: 48.2558,
    y1: 5.82218,
    x2: 45.5969,
    y2: 1.21706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_335",
    x1: 9.49495,
    y1: 15.8437,
    x2: 10.1932,
    y2: 14.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#236568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F878A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_715_335",
    x1: 12.0352,
    y1: 18.8666,
    x2: 9.37632,
    y2: 14.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F878A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06DAAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_715_335",
    x1: 19.8921,
    y1: 25.8607,
    x2: 21.2123,
    y2: 23.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_715_335",
    x1: 21.6439,
    y1: 26.9957,
    x2: 23.0851,
    y2: 24.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_715_335",
    x1: 28.8054,
    y1: 31.5239,
    x2: 30.2233,
    y2: 29.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_715_335",
    x1: 34.6478,
    y1: 34.1621,
    x2: 41.2934,
    y2: 34.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095510);
export default __webpack_public_path__ + "static/media/Group 48095510.bd7ad7e48768d6a6f22b26cc61babe24.svg";
export { ForwardRef as ReactComponent };